import React, { Component, } from 'react'

class NotesTeamItem extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row',
          marginBottom: 10 }}>
        <span
          style={{ display: 'flex', flexShrink: '0',
            color: 'rgba(0,0,0,0.8)', fontSize: 14 }}>
          {this.props.name + ':'}
        </span>
        <span
          style={{ display: 'flex', marginLeft: 5,
            color: 'rgba(0,0,0,0.4)', fontSize: 14 }}>
          {this.props.note}
        </span>
      </div>
    );
  }
}

export default NotesTeamItem;



// WEBPACK FOOTER //
// ./src/schedule/common/modules/notes/NotesTeamItem.js